import { SimpleNotificationsModule } from 'angular2-notifications';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NavbarComponent } from '../navbar/navbar.component';
import { DropdownModule } from 'ngx-dropdown';
import { LayoutModule } from '@angular/cdk/layout';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [
    NavbarComponent
  ],
  imports: [
    BrowserModule,
    LayoutModule,
    RouterModule,
    DropdownModule,
    SimpleNotificationsModule.forRoot(),
    TranslateModule
  ],
  providers: [],
  bootstrap: [NavbarComponent],
  exports: [NavbarComponent],
})
export class NavModule { }



// WEBPACK FOOTER //
// ./src/app/layout/navbar/navbar.module.ts